import React, { useState } from 'react';
import { useCardContext } from '../contexts/CardContext';

export default function CardForm() {
    const [cardNumber, setCardNumber] = useState('');
    const [error, setError] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const { setCardNumber: saveCardNumber } = useCardContext();

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);
        let newError = '';

        // Валідація номера карти: перевірка наявності, довжини від 5 до 16 і тільки цифри
        if (!cardNumber) {
            newError = 'Будь ласка, введіть номер карти.';
        } else if (cardNumber.length < 5 || cardNumber.length > 16 || !/^\d+$/.test(cardNumber)) {
            newError = 'Номер карти має містити від 5 до 16 цифр.';
        }

        setError(newError);

        if (!newError) {
            // Зберігаємо картку в локальному сховищі
            localStorage.setItem('cardNumber', cardNumber);
            saveCardNumber(cardNumber);
        }
    };

    const handleCardNumberChange = (e) => {
        setCardNumber(e.target.value);
        if (error) {
            setError('');
        }
    };

    const styles = {
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
            padding: '20px',
        },
        logo: {
            margin: '20px',
            width: '200px',
        },
        form: {
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
            width: '300px',
            padding: '20px',
            border: '1px solid #ddd',
            borderRadius: '8px',
            backgroundColor: '#f9f9f9',
        },
        title: {
            textAlign: 'center',
            fontSize: '20px',
            fontWeight: 'bold',
            marginBottom: '10px',
        },
        inputContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            width: '300px',
        },
        label: {
            fontSize: '14px',
            marginBottom: '5px',
        },
        input: {
            width: '300px',
            padding: '8px',
            fontSize: '16px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            boxSizing: 'border-box',
        },
        inputError: {
            border: '1px solid red',
            backgroundColor: '#ffe6e6',
            width: '300px',
            boxSizing: 'border-box',
        },
        errorPlaceholder: {
            minHeight: '18px',
        },
        errorText: {
            color: 'red',
            fontSize: '12px',
        },
        button: {
            padding: '10px 20px',
            fontSize: '16px',
            backgroundColor: '#1f83fe',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            boxShadow: '0 8px 20px #5b88f152',
            transition: 'background-color 0.3s ease',
            alignSelf: 'center',
        },
    };

    return (
        <div style={styles.container}>
            <img src="./logo_v2.png" alt="epass Logo" style={styles.logo} />
            <form onSubmit={handleSubmit} style={styles.form}>
                <h2 style={styles.title}>Перевірка балансу</h2>
                <div style={styles.inputContainer}>
                    <label style={styles.label}>Номер транспортної карти:</label>
                    <input
                        type="text"
                        value={cardNumber}
                        onChange={handleCardNumberChange}
                        placeholder="Введіть номер карти"
                        style={{ ...styles.input, ...(submitted && error ? styles.inputError : {}) }}
                    />
                    <div style={styles.errorPlaceholder}>
                        {submitted && error && <span style={styles.errorText}>{error}</span>}
                    </div>
                </div>
                <button type="submit" style={styles.button}>
                    Перевірити баланс
                </button>
            </form>
        </div>
    );
}